import styled, { css, keyframes } from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';

export const InvestmentDetailsStyles = styled(Flex)<FlexProps>`
	flex-direction: column;
	overflow: hidden;

	.main {
		display: flex;
		gap: 1rem;
		margin-top: 1rem;
		overflow: hidden;
		height: 100%;

		> .content,
		> .sidebar {
			height: 100%;
			overflow: auto;
			padding-bottom: 2rem;
			scrollbar-width: none;
			-ms-overflow-style: none;

			&::-webkit-scrollbar {
				width: 0;
				height: 0;
			}
		}

		> .content {
			flex: 1 1 76%;
		}

		> .sidebar {
			flex: 1 1 24%;
		}
	}
`;

export const PAYMENT_HIGHLIGHT_DURATION_MS = 1600;

export const sidebarPaymentHighlightPulse = keyframes`
	0% { box-shadow: inset 0 0 0 0 rgba(59, 130, 246, 0.7); }
	50% { box-shadow: inset 0 0 0 4px rgba(59, 130, 246, 0.65); }
	100% { box-shadow: inset 0 0 0 0 rgba(59, 130, 246, 0); }
`;

export const SidebarPaymentCardAnchor = styled.div<{ $highlighted: boolean }>`
	border-radius: 0.5rem;
	${({ $highlighted }) =>
		$highlighted &&
		css`
			animation: ${sidebarPaymentHighlightPulse} ${PAYMENT_HIGHLIGHT_DURATION_MS}ms ease-out;
		`}
`;
